import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { EXTENSION_NAME_PATTERN } from '@/config/constants';

export function NotFoundPage() {
  const navigate = useNavigate();

  // If the bare path looks like an appCode, redirect to /{appCode}/inbox
  useEffect(() => {
    const path = window.location.pathname.replace(/^\/|\/$/g, '');
    // Single segment that matches appCode pattern (e.g. "twilioforzohocrm" or "calendlyforzohocrm")
    if (path && !path.includes('/') && (EXTENSION_NAME_PATTERN.test(path) || path.includes('for'))) {
      // Keep the query string: marketplace "Install" links land here as
      // /{appCode}?suggestLoginMail=… and dropping it loses the account
      // hand-off before anything downstream can check it.
      navigate(`/${path}/inbox${window.location.search}`, { replace: true });
    }
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="max-w-sm text-center space-y-6">
        <div className="text-8xl font-bold text-primary/20">404</div>
        <div>
          <h1 className="text-2xl font-bold text-foreground">Page Not Found</h1>
          <p className="text-sm text-muted-foreground mt-2">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>
        <div className="flex items-center justify-center gap-3">
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center gap-2 rounded-lg border border-border px-4 py-2 text-sm font-medium text-foreground hover:bg-muted transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            Go Back
          </button>
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors"
          >
            <Home className="h-4 w-4" />
            Home
          </Link>
        </div>
      </div>
    </div>
  );
}
